<template>
  <div id="log-in-form">
    <h5 class="title is-5 has-text-centered">
      Log In
    </h5>
    <form @submit.prevent="validateBeforeSubmit()">
      <div class="field">
        <label class="label">Email</label>
        <div class="control">
          <input
            v-model="email"
            v-validate="'required'"
            class="input"
            name="email"
            type="text"
          >
          <p class="help is-danger">
            {{ errors.first('email') }}
          </p>
        </div>
      </div>
      <div class="field">
        <label class="label">Password</label>
        <div class="control has-icons-right">
          <input
            v-model="password"
            v-validate="'required'"
            class="input"
            :type="!passwordIsShowing ? 'password' : 'text'"
            name="password"
          >
          <span
            id="show-password"
            class="icon is-small is-right"
            :class="passwordIsShowing ? 'has-text-primary' : ''"
            @click="toggleShowPassword()"
          >
            <i class="fas fa-eye" />
          </span>
          <p class="help is-danger">
            {{ errors.first('password') }}
          </p>
          <div class="has-text-right">
            <span class="button is-small is-text" @click="handleClickForgotPassword">
              Forgot password?
            </span>
          </div>
        </div>
      </div>
      <div class="control has-text-centered">
        <button
          type="submit"
          class="button is-rounded is-primary has-text-weight-bold is-fullwidth login-button"
          :class="isLoading ? 'is-loading' : ''"
        >
          Log In
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'LogInForm',
  data () {
    return {
      email: '',
      password: '',
      passwordIsShowing: false,
      isLoading: false
    };
  },
  methods: {
    sendUserLogIn () {
      this.isLoading = true;
      this.$store
        .dispatch('logInUser', {
          email: this.email.toLowerCase(),
          password: this.password
        })
        .then(response => {
          this.isLoading = false;
          this.$socket.open();
          this.$router.push({ path: '/dashboard' });
        })
        .catch(error => {
          this.isLoading = false;
          if (error.data && error.data.details) {
            console.log(error);
            this.$toasted.show(error.data.details);
          } else {
            this.$toasted.show('Email or password incorrect');
            console.log(error);
            this.isLoading = false;
          }
        });
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendUserLogIn();
          return;
        }
        console.log('Correct them errors!');
      });
    },
    toggleShowPassword () {
      this.passwordIsShowing = !this.passwordIsShowing;
    },
    handleClickForgotPassword () {
      this.$emit('togglePasswordResetForm');
    }
  }
};
</script>

<style lang="scss" scoped>
.login-button {
  margin-top: 1.5rem;
}

.icon {
  pointer-events: initial !important;
}

#show-password {
  cursor: pointer;
}

#show-password:hover {
  color: $primary;
}
</style>
